import React from "react";
import { Container, Row, Col } from "reactstrap";
import UserList from "./UserList";

const Users = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">BackOffice Users</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <UserList />
        </Col>
      </Row>
    </Container>
  );
};

export default Users;
